import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MAIN_PLANS } from './planes.routes';
import { CardsPlansComponent } from './cards-plans/cards-plans.component';
import { CardsPlanComponent } from './cards-plan/cards-plan.component';
import { TablePlanComponent } from './table-plan/table-plan.component';
import { PanelPlanComponent } from './panel-plan/panel-plan.component';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { PlanesComponent } from './planes.component';
import { ModalPlansComponent } from './modal-plans/modal-plans.component';
import { ModalDowngradeComponent } from './modal-downgrade/modal-downgrade.component';
import { ModalAlertComponent } from './modal-alert/modal-alert.component';
import { ModalFormDesaffiliationComponent } from './modal-form-desaffiliation/modal-form-desaffiliation.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@NgModule({
  declarations: [
    PlanesComponent,
    CardsPlansComponent,
    CardsPlanComponent,
    TablePlanComponent,
    PanelPlanComponent,
    ModalPlansComponent,
    ModalDowngradeComponent,
    ModalAlertComponent,
    ModalFormDesaffiliationComponent
  ],
  imports: [
    CommonModule,
    MAIN_PLANS,
    FormsModule,
    MatButtonModule,
    MatExpansionModule,
    MatProgressBarModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatInputModule,
    MatProgressSpinnerModule,
  ],
})
export class PlansModule {}
